export default __webpack_public_path__ + "static/media/default-characters.4d02e628.jpg";